<template>
  <div class="content">
    <el-dialog
      title="运营报告"
      class="flow-dialog"
      :visible.sync="dialogVisible"
      width="80%"
      @close="close"
    >
      <div class="content-main-box content-main-box2">
        <!-- 搜索区域 -->
        <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="search-area-div w80">关键字搜索</div>
              <el-input
                v-model="operationPage.searchKey"
                placeholder="请输入企业、组织、应付金额搜索"
                size="mini"
                class="ipt-sty"
              >
              </el-input>
            </el-col>
            <el-col :span="8" class="search-btn-box">
              <el-button size="mini" type="info" @click="getOperationList"
                >搜索</el-button
              >
              <el-button size="mini" type="danger" @click="emptyOperationSearch"
                >清空</el-button
              >
            </el-col>
          </el-row>
        </div>

        <!-- 表格区域 -->
        <el-table
          stripe
          border
          ref="operationTable"
          highlight-current-row
          :data="operationTableData"
          :row-key="(row) => row.guid"
          :current-row-key="currentRowKey"
          @row-click="flowListsChange"
          @select="handleSelectFlow"
          :header-cell-class-name="cellClass"
          :max-height="320"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            :show-header="false"
          >
          </el-table-column>
          <!-- 流程名称 -->
          <el-table-column
            prop="flowName"
            min-width="120"
            label="流程名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 发起人 -->
          <el-table-column
            prop="staffName"
            label="发起人"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 药企名称 -->
          <el-table-column
            prop="bizTenantName"
            label="药企名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="serviceTenantNames"
            label="总服务商"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.serviceTenantNameStr || "-" }}
            </template>
          </el-table-column>
          <!-- 组织名称 -->
          <el-table-column
            prop="organisationName"
            label="组织名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.bizOrganisationName || "-" }}
            </template>
          </el-table-column>
          <!-- 核算月 -->
          <el-table-column
            prop="accountMonthName"
            min-width="96"
            label="核算月"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 账单周期 -->
          <el-table-column
            prop="billCycleList"
            label="账单周期"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.billCycleList
                  ? scope.row.billCycleList.join("、")
                  : "-"
              }}
            </template>
          </el-table-column>
          <!-- 任务包名称 -->
          <el-table-column
            prop="taskTitleName"
            min-width="120"
            label="任务包名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 应付金额 -->
          <el-table-column
            prop="currentPayAmount"
            min-width="96"
            label="应付金额(元)"
            header-align="center"
            align="right"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.currentPayAmount | numFmt | numDigit
            }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer">
        <el-button plain size="mini" @click="close">取消</el-button>
        <el-button size="mini" type="info" @click="selectProcess"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OperationReportDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      selectSettDoc: [],
      detailData: {},
      operationPage: {
        pageIndex: 1,
        pageSize: -1,
        approveState: "Y",
        flowType: "00016",
        isUsedQuality: "N",
        isUsedOperationReport: "N",
        searchKey: null,
        tenantGuid: null,
        flowStaffGuids: [],
        isChangeService: "N",
      },
      operationTableData: [],
      currentRow: {},
      currentRowKey: null,
    };
  },
  methods: {
    open(data) {
      this.selectSettDoc = data?.selectSettDoc || [];
      this.detailData = data?.detailData || {};
      this.dialogVisible = true;
      this.getOperationList();
    },
    close() {
      this.dialogVisible = false;
      this.$refs.operationTable?.clearSelection();
      this.currentRow = {};
      this.currentRowKey = null;
      this.$emit("close");
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    handleSelectFlow(selection, row) {
      this.$refs.operationTable.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.currentRow = row;
        this.currentRowKey = row.guid;
        this.$refs.operationTable.toggleRowSelection(row, true);
      }
    },
    flowListsChange(row) {
      this.$refs.operationTable.clearSelection();
      row.flag = !row.flag;
      this.$refs.operationTable.toggleRowSelection(row, row.flag);
      this.currentRowKey = row.guid;
      this.currentRow = row;
    },
    selectProcess() {
      let { currentRow } = this;
      if (!currentRow.guid) {
        return this.$message.error("请关联流程");
      }
      this.$emit("submit", currentRow);
      this.close();
    },
    async getOperationList() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let billCycleList = this.selectSettDoc?.[0]?.billCycleList;
      // 编辑时 并且有关联流程 使用详情 期数
      if (this.detailData?.billCycleList && this.detailData?.parentGuid) {
        billCycleList = this.detailData.billCycleList;
      }
      let serviceTenantGuid = this.selectSettDoc?.[0]?.tenantGuid;
      if (this.detailData?.serviceTenantGuid && this.detailData?.parentGuid) {
        // 编辑时 并且有关联流程 使用详情 服务商
        serviceTenantGuid = this.detailData.tenantGuid;
      }
      let operationReportTenantGuid =
        this.selectSettDoc?.[0]?.operationReportTenantGuid;
      if (
        this.detailData?.operationReportTenantGuid &&
        this.detailData?.parentGuid
      ) {
        // 编辑时 并且有关联流程 使用详情 运营报告服务商
        operationReportTenantGuid = this.detailData.operationReportTenantGuid;
      }
      const params = {
        tenantGuid: operationReportTenantGuid,
        // newServiceTenantGuids: serviceTenantGuid,
        searchKey: this.operationPage.searchKey,
        // billCycleList: billCycleList,
        staffGuid: userInfo.staffGuid,
        usedGuid: this.detailData?.operationReportGuid || "",
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/upstream/payment/select-list`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.operationTableData = (data.data || []).map((item) => {
        let serviceTenantNameStr = "-";
        if (item.serviceTenantNames?.length === 1) {
          serviceTenantNameStr = item.serviceTenantNames[0];
        }
        if (item.serviceTenantNames?.length >= 2) {
          serviceTenantNameStr =
            item.serviceTenantNames.slice(0, 2).join("、") +
            "等" +
            item.serviceTenantNames.length +
            "个服务商";
        }
        return {
          ...item,
          serviceTenantNameStr: serviceTenantNameStr,
        };
      });

      // 如果已经选择了运营报告，自动勾选对应的行
      if (this.detailData.operationReportGuid) {
        this.$nextTick(() => {
          const selectedRow = this.operationTableData.find(
            (item) => item.guid === this.detailData.operationReportGuid
          );
          if (selectedRow) {
            this.currentRow = selectedRow;
            this.currentRowKey = selectedRow.guid;
            this.$refs.operationTable?.toggleRowSelection(selectedRow, true);
          }
        });
      }
    },
    emptyOperationSearch() {
      this.operationPage.searchKey = null;
      this.getOperationList();
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  .search-btn-box {
    justify-content: flex-start;
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }
}

::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
  line-height: 37px;
}
</style>
